module.exports = __webpack_public_path__ + "static/media/gas-safe-register.60ae6998.jpg";